module.exports = __webpack_public_path__ + "b7018be9ed6cd94da8b6675b3a468c3b.woff2";